import React from 'react';
import langText from '../../../helpers/langText';

const CApllicantItem = ({ data }) => {
 
  const applicantDetails = data?.applicant;
  const date1 = new Date();
  const date2 = new Date(applicantDetails?.createdAt);
  const diffTime = Math.abs(date2 - date1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  console.log(data, 'datadata')
  if (!applicantDetails) return <></>;
  return (
    <div className='job--item'>
      {/* Image */}
      <div
        className='master--imageContainer lazyload'
        data-bg='assets/images/02.png'
        style={{
          backgroundImage: `url(${
            data?.artisan?.logo
              ? data?.artisan?.logo
              : require('../../../assets/images/placeholders/placeholder-250x250.png')
          })`
        }}
      />
      {/* Data */}
      <div className='data'>
        <div className='date exep-1'>منذ {diffDays} ايام</div>
        <div className='title exep-1'>Moahmmed Abdelhady</div>
        <div className='subtitle exep-1'>
          سنوات الخبرة {applicantDetails?.yearsOfExperience}
        </div>
        {/* <div className='subtitle exep-1'>
          {langText(
            applicantDetails?.applicantBIO,
            applicantDetails?.applicantBIOi18n
          )}
        </div> */}
      </div>
      
    </div>
  );
};

export default CApllicantItem;
